import dayjs from "dayjs";
import { locale, t } from "../MainApp";

type PaymentWholeHallReservationProps = {    
    payableData: TPaymentData | undefined;
    locale: locale;
};

type TResponseType = {
    type: string;
    schema_version: number;
}

export type TPaymentData = TResponseType & {
    is_employee: boolean;
    free_for_employees: boolean;
    item_name: string;
    quantity: number;
    price_per_unit: number;
    discount: number;
    member_discount: number;
    applied_discount: number;
    unit_duration_in_minutes: number;

    remaining_item_name?: string;
    remaining_item_quantity?: number;
    remaining_item_price_per_unit?: number;
    remaining_discount?: number;
    remaining_member_discount?: number;
    remaining_applied_discount? : number;
    remaining_unit_duration_in_minutes?: number;

    total: number;
};

export function PaymentTableWholeHallReservation(props: PaymentWholeHallReservationProps) {    
    function minutes_to_human(minutes: number): string {
        const h = Math.floor(minutes / 60);
        const m = minutes % 60;
        
        if(m >= 10) {
            return `${h}:${m}`;
        } else {
            return `${h}:0${m}`;
        }
    }

    function to_precision(x: number) {
        return Number(x).toFixed(2);
    } 

    return (
        <>
            {props.payableData !== undefined ? 
                props.payableData.type === 'free' ? <></> : 
                <table className="order_table">
                    <colgroup>
                        <col style={{color: 'black'}} />
                        <col style={{fontWeight: 'bold'}} />
                    </colgroup>
                    <thead>
                        <tr style={{borderBottom: '1px solid #ddd'}}>
                            <th>{t(props.locale, 'payment_table_header_description')}</th>
                            <th>{t(props.locale, 'payment_table_header_value')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{t(props.locale, 'payment_table_body_employee_key')}</td>
                            <td>{props.payableData.is_employee ? t(props.locale, 'payment_table_body_employee_true') : t(props.locale, 'payment_table_body_employee_false')}</td>
                        </tr>
                        <tr style={{borderBottom: '1px solid #ddd'}}>
                            <td>{t(props.locale, 'payment_table_body_free_for_employees_key')}</td>
                            <td>{props.payableData.free_for_employees ? t(props.locale, 'payment_table_body_free_for_employees_true') : t(props.locale, 'payment_table_body_free_for_employees_false')}</td>
                        </tr>                    
                        <tr>
                            <td>{t(props.locale, 'payment_table_body_product_name_key')}</td>
                            <td>{props.payableData.item_name}</td>
                        </tr>
                        <tr>
                            <td>{t(props.locale, 'payment_table_body_product_quantity_key')} * {minutes_to_human(props.payableData.unit_duration_in_minutes)}h * {t(props.locale, 'payment_table_body_quantity_unit')}</td>
                            <td>{to_precision(props.payableData.quantity)}</td>
                        </tr>
                        <tr>
                            <td>{t(props.locale, 'payment_table_body_price_key')} / {t(props.locale, 'payment_table_body_quantity_unit')}</td>
                            <td>{to_precision(props.payableData.price_per_unit)} {t(props.locale, 'payment_table_body_price_unit')}</td>
                        </tr>
                        <tr>
                            <td>{t(props.locale, 'payment_table_body_discount_key')} / {t(props.locale, 'payment_table_body_quantity_unit')}</td>
                            <td>{to_precision(props.payableData.discount)} {t(props.locale, 'payment_table_body_price_unit')}</td>
                        </tr>
                        <tr>
                            <td>{t(props.locale, 'payment_table_body_member_discount_key')} / {t(props.locale, 'payment_table_body_quantity_unit')}</td>
                            <td>{to_precision(props.payableData.member_discount)} {t(props.locale, 'payment_table_body_price_unit')}</td>
                        </tr>
                        <tr style={{borderBottom: '1px solid #ddd'}}>
                            <td>{t(props.locale, 'payment_table_body_effective_discount_key')} / {t(props.locale, 'payment_table_body_quantity_unit')}</td>
                            <td>{to_precision(props.payableData.applied_discount)} {t(props.locale, 'payment_table_body_price_unit')}</td>
                        </tr>                        
                        { props.payableData.remaining_item_name && props.payableData.remaining_item_quantity && props.payableData.remaining_item_price_per_unit && props.payableData.remaining_discount && props.payableData.remaining_member_discount && props.payableData.remaining_applied_discount && props.payableData.remaining_unit_duration_in_minutes ? 
                        <>
                        <tr>
                            <td>{t(props.locale, 'payment_table_body_product_name_key')}</td>
                            <td>{props.payableData.remaining_item_name}</td>
                        </tr>
                        <tr>
                            <td>{t(props.locale, 'payment_table_body_product_quantity_key')} * {minutes_to_human(props.payableData.remaining_unit_duration_in_minutes)}h * {t(props.locale, 'payment_table_body_quantity_unit')}</td>
                            <td>{to_precision(props.payableData.remaining_item_quantity)}</td>
                        </tr>
                        <tr>
                            <td>{t(props.locale, 'payment_table_body_price_key')} / {t(props.locale, 'payment_table_body_quantity_unit')}</td>
                            <td>{to_precision(props.payableData.remaining_item_price_per_unit)} {t(props.locale, 'payment_table_body_price_unit')}</td>
                        </tr>
                        <tr>
                            <td>{t(props.locale, 'payment_table_body_discount_key')} / {t(props.locale, 'payment_table_body_quantity_unit')}</td>
                            <td>{to_precision(props.payableData.remaining_discount)} {t(props.locale, 'payment_table_body_price_unit')}</td>
                        </tr>
                        <tr>
                            <td>{t(props.locale, 'payment_table_body_member_discount_key')} / {t(props.locale, 'payment_table_body_quantity_unit')}</td>
                            <td>{to_precision(props.payableData.remaining_member_discount)} {t(props.locale, 'payment_table_body_price_unit')}</td>
                        </tr>
                        <tr style={{borderBottom: '1px solid #ddd'}}>
                            <td>{t(props.locale, 'payment_table_body_effective_discount_key')} / {t(props.locale, 'payment_table_body_quantity_unit')}</td>
                            <td>{to_precision(props.payableData.remaining_applied_discount)} {t(props.locale, 'payment_table_body_price_unit')}</td>
                        </tr>
                        </>
                        : <></> }                        
                    </tbody>
                    <tfoot>
                        <tr>
                            <td style={{color: 'black'}}><strong>{t(props.locale, 'payment_table_body_total_due_key')}</strong></td>
                            <td style={{color: 'red'}}><strong>{to_precision(props.payableData.total)} {t(props.locale, 'payment_table_body_price_unit')}</strong></td>
                        </tr>
                    </tfoot>
                </table>
                : <></>
            }
        </>
    );
};